import React from 'react';
import { Trans } from 'react-i18next';

/**
 * A component which handles our default i18next Trans usage.
 * Replacing predefined tags in translation values with the correct HTML elements
 */
const DefaultTrans = ({ translatedString }) => {
    return (
        <Trans
            components={{
                p: <p />,
                b: <b />,
                strong: <strong />,
                u: <u />,
            }}
        >
            {translatedString}
        </Trans>
    );
};

export default DefaultTrans;
